"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/* eslint-disable id-length */
var _default = exports.default = {
  MAX_AUTO_COMPLETE_LENGTH: 10,
  DEFAULT_SEARCH_COMPARISON_CARDS: {
    variant: 'search-comparison',
    cardConfigs: [{
      type: 'basic',
      title: 'searchComparisonCards.basicSearch.title',
      description: 'searchComparisonCards.basicSearch.description',
      icon: 'search',
      iconColor: 'black',
      mediaType: 'video'
    }, {
      type: 'ai',
      title: 'searchComparisonCards.aiSearch.title',
      description: 'searchComparisonCards.aiSearch.description',
      icon: 'sparkles',
      iconColor: 'purple',
      mediaType: 'video'
    }]
  },
  CUSTOM_ANIMATIONS_SEARCH_COMPARISON_CARDS: {
    variant: 'search-comparison',
    cardConfigs: [{
      type: 'basic',
      title: 'searchComparisonCards.basicSearch.title',
      description: 'searchComparisonCards.basicSearch.description',
      icon: 'search',
      iconColor: 'black',
      mediaType: 'none',
      customAnimation: {
        text: 'searchComparisonCards.basicSearch.example',
        tldList: ['.org', '.biz', '.shop', '.com'],
        delay: 100,
        loopDelay: 4000
      }
    }, {
      type: 'ai',
      title: 'searchComparisonCards.aiSearch.title',
      description: 'searchComparisonCards.aiSearch.description',
      icon: 'sparkles',
      iconColor: 'purple',
      mediaType: 'none',
      customAnimation: {
        text: 'searchComparisonCards.aiSearch.example'
      }
    }]
  },
  STATIC_SEARCH_COMPARISON_CARDS: {
    variant: 'search-comparison',
    cardConfigs: [{
      type: 'basic',
      title: 'searchComparisonCards.basicSearch.title',
      description: 'searchComparisonCards.basicSearch.description',
      icon: 'search',
      iconColor: 'black',
      mediaType: 'image'
    }, {
      type: 'ai',
      title: 'searchComparisonCards.aiSearch.title',
      description: 'searchComparisonCards.aiSearch.description',
      icon: 'sparkles',
      iconColor: 'purple',
      mediaType: 'image'
    }]
  }
};